<template>
	<div class="user flex main other_main">
		<asiden :asideData="asideList"></asiden>
		<div class="main_r">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import asiden from "../layout/aside/aside.vue";
export default {
	components: { asiden },
	name: "PredictionIndex",
	data() {
		return {
			asideList: [
				{
					title: "事件列表",
					icon: "",
					router: "/prediction",
					permissions: 1101,
				},
			],
		};
	},
	mounted() {
		// 开发阶段暂时注释权限检查

		const role_permissions = this.$store.state.user.user.role_permissions;
		if (role_permissions) {
			const permissionArray = role_permissions.split(",").map(Number);
			this.asideList = this.asideList.filter((item) =>
				permissionArray.includes(item.permissions),
			);
		}
	},
};
</script>

<style scoped></style>
